import { useContext } from 'react'
import { ToastContext } from '../contexts/toast-context'

/**
 * useToast - Hook to access toast notification functionality
 * 
 * Provides the `showToast` function to display success or error notifications.
 * Must be used within a ToastProvider component tree.
 * 
 * @returns Toast context containing showToast function
 * @throws Error if used outside of ToastProvider
 * 
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { showToast } = useToast()
 *   
 *   const handleSuccess = () => {
 *     showToast('success', 'Operazione completata', 'I dati sono stati salvati')
 *   }
 *   
 *   const handleError = () => {
 *     showToast('error', 'Errore', 'Impossibile salvare i dati')
 *   }
 *   
 *   return <button onClick={handleSuccess}>Save</button>
 * }
 * ```
 */
export function useToast() {
  const context = useContext(ToastContext)
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}
